/* ==========================================================================
   Mini Maxx — product page
   Two concerns: switching the fitment option updates price/SKU/availability
   and the hidden variant id, and the thumb rail swaps the main image or
   plays a product video in its place.
   Everything degrades to a working native form if this never runs.
   ========================================================================== */

(function () {
  'use strict';

  function stopVideo(slot) {
    slot.hidden = true;
    var video = slot.querySelector('video');
    if (video) video.pause();
    // Embedded players can't be paused from here; removing the iframe stops
    // playback, and the template re-creates it next time.
    var iframe = slot.querySelector('iframe');
    if (iframe) iframe.remove();
  }

  function startVideo(slot) {
    slot.hidden = false;
    var video = slot.querySelector('video');
    if (video) {
      video.play().catch(function () {});
      return;
    }
    var template = slot.querySelector('template');
    if (template && !slot.querySelector('iframe')) {
      slot.appendChild(template.content.cloneNode(true));
    }
  }

  function showMedia(root, mediaId, src) {
    var main = root.querySelector('[data-mm-stage] > img.mm-pdp__img');
    var target = null;

    root.querySelectorAll('[data-mm-video]').forEach(function (slot) {
      if (slot.dataset.mmVideo === mediaId) {
        target = slot;
      } else {
        stopVideo(slot);
      }
    });

    if (target) {
      if (main) main.hidden = true;
      startVideo(target);
    } else {
      if (!main || !src) return;
      main.hidden = false;
      main.src = src;
      // The responsive candidates belong to the old image; leaving them set
      // lets the browser pick a source that no longer matches.
      main.removeAttribute('srcset');
    }

    root.querySelectorAll('[data-mm-thumb]').forEach(function (thumb) {
      if (mediaId && thumb.dataset.mediaId === mediaId) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }

  function bindVariants(root) {
    var radios = root.querySelectorAll('[data-mm-variant-radio]');
    if (!radios.length) return;

    var idField = root.querySelector('[data-mm-variant-id]');
    var priceEl = root.querySelector('[data-mm-price]');
    var compareEl = root.querySelector('[data-mm-compare]');
    var skuEl = root.querySelector('[data-mm-sku]');
    var addBtn = root.querySelector('[data-mm-add]');
    var addLabel = root.querySelector('[data-mm-add-label]');

    function apply(radio) {
      if (idField) idField.value = radio.value;
      if (priceEl) priceEl.textContent = radio.dataset.price || '';

      if (compareEl) {
        var compare = radio.dataset.compare || '';
        compareEl.textContent = compare;
        // hidden rather than display:none so the strike-through element keeps
        // its place in the baseline row when it comes back.
        compareEl.hidden = compare === '';
      }

      if (skuEl) skuEl.textContent = radio.dataset.sku || '';

      var available = radio.dataset.available === 'true';
      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Currently unavailable';
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        apply(radio);
        // Only on change: the server already rendered the selected variant's
        // image with its srcset on load.
        if (radio.dataset.image) showMedia(root, radio.dataset.mediaId, radio.dataset.image);
      });
      if (radio.checked) apply(radio);
    });
  }

  function bindGallery(root) {
    var thumbs = root.querySelectorAll('[data-mm-thumb]');
    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showMedia(root, thumb.dataset.mediaId, thumb.dataset.full);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-mm-pdp]').forEach(function (root) {
      bindVariants(root);
      bindGallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
